import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_account")({
	beforeLoad: ({ context }) => {
		// Pass through context from parent route to child routes
		return context;
	},
	component: Outlet,
});
